import React from "react";
import "./Politicas.css";
import Footer from "../Footer/Footer";

export default function Terminos() {
  const lastUpdated = "8 de octubre de 2026"; // actualizá si hace falta

  return (
    <>
      <main className="pp-root" role="main">
        <article className="pp-card">
          <header className="pp-header">
            <h1>Condiciones del Servicio</h1>
            <p className="pp-meta">Última actualización: {lastUpdated}</p>
          </header>

          <section>
            <h2>1. Aceptación de las condiciones</h2>
            <p>
              Estas Condiciones del Servicio regulan el uso del sitio web y los servicios de{" "}
              <strong>Sole Costilla Group</strong> (en adelante "nosotros", "nuestro/a"). Al contratar
              nuestros servicios, navegar en la web, crear una cuenta o conectar tu Google Drive,
              aceptás estas condiciones y nuestra <a href="/politicas">Política de Privacidad</a>.
              Si no estás de acuerdo, no uses nuestros servicios.
            </p>
          </section>

          <section>
            <h2>2. Servicios que ofrecemos</h2>
            <p>Prestamos servicios de fotografía y video, incluyendo:</p>
            <ul>
              <li>Sesiones fotográficas (bodas, eventos, retratos y sesiones comerciales).</li>
              <li>Reservas y contratación de fechas a través de la web.</li>
              <li>Entrega digital de fotografías y videos editados.</li>
              <li>Gestión de sesiones, clientes y contratos desde el panel del cliente.</li>
            </ul>
          </section>

          <section>
            <h2>3. Uso de la cuenta y del sitio</h2>
            <p>
              Al crear una cuenta te comprometés a proporcionar información verdadera y a mantenerla
              actualizada. Sos responsable de la confidencialidad de tu acceso y de toda actividad que
              ocurra en tu cuenta. Queda prohibido usar el sitio para fines ilegales, reproducir,
              revender o explotar nuestros servicios sin autorización previa.
            </p>
          </section>

          <section>
            <h2>4. Reservas, pagos y cancelaciones</h2>
            <p>
              La reserva de una fecha se confirma una vez completado el pago acordado o la seña
              correspondiente. Las condiciones de cancelación y reprogramación se informan al momento
              de la contratación y según lo pactado en el contrato de servicios. Los pagos se procesan
              a través de nuestros proveedores de pago; no guardamos los datos de tu tarjeta.
            </p>
          </section>

          <section>
            <h2>5. Conexión con Google Drive para la entrega de fotos</h2>
            <p>
              Para entregarte tus fotografías y videos editados usamos Google Drive. Al conectar tu
              cuenta de Google:
            </p>
            <ul>
              <li>Solo accedemos a la información y a las carpetas estrictamente necesarias para copiar y ponerte a disposición tus archivos.</li>
              <li>No leemos ni modificamos otros archivos de tu cuenta.</li>
              <li>No compartimos tu información con terceros.</li>
              <li>El acceso se limita a la finalidad declarada y podés revocarlo en cualquier momento desde tu cuenta de Google (Google Account → Seguridad → Apps de terceros) o desde nuestro panel de sesiones.</li>
            </ul>
            <p>
              Al autorizar la conexión nos otorgás un permiso limitado, no exclusivo, para administrar
              la carpeta que creamos para tu entrega. Si eliminás la conexión, tus archivos ya
              entregados no se ven afectados.
            </p>
          </section>

          <section>
            <h2>6. Propiedad intelectual</h2>
            <p>
              Todas las fotografías y videos producidos por <strong>Sole Costilla Group</strong> son de
              nuestra autoría. Te otorgamos el derecho de uso personal y no comercial de las imágenes
              de tu sesión. Queda prohibida su venta, distribución o uso comercial sin nuestro
              consentimiento previo por escrito, salvo acuerdo específico. Podés pedirnos la
              eliminación de tus archivos; esto puede limitar reimpresiones o copias futuras.
            </p>
          </section>

          <section>
            <h2>7. Enlaces y servicios de terceros</h2>
            <p>
              Nuestro sitio puede contener enlaces a sitios o servicios de terceros (pagos, Google,
              WhatsApp, redes sociales). No somos responsables por el contenido, políticas ni prácticas
              de esos terceros. Te recomendamos revisar sus términos y políticas de privacidad.
            </p>
          </section>

          <section>
            <h2>8. Limitación de responsabilidad</h2>
            <p>
              Realizamos los servicios con el debido cuidado y profesionalismo. En la medida permitida
              por la ley, nuestra responsabilidad se limita al importe pagado por el servicio
              contratado y no responderemos por daños indirectos, pérdida de datos, interrupción de
              servicios de terceros (incluido Google Drive) o incidentes fuera de nuestro control.
            </p>
          </section>

          <section>
            <h2>9. Modificaciones</h2>
            <p>
              Podemos actualizar estas condiciones en cualquier momento. Los cambios se publicarán en
              esta página con su fecha de actualización. El uso continuado de la web o de nuestros
              servicios después de una modificación implica su aceptación.
            </p>
          </section>

          <section>
            <h2>10. Ley aplicable y jurisdicción</h2>
            <p>
              Estas condiciones se rigen por las leyes de la República Argentina. Ante cualquier
              controversia, las partes se someten a los tribunales ordinarios de la provincia de
              Tucumán, renunciando a otros fueros.
            </p>
          </section>

          <section>
            <h2>11. Contacto</h2>
            <p>
              Por consultas sobre estas condiciones, escribí a:
              <br />
              <a href="mailto:scgroup@gmail.com">scgroup@gmail.com</a>
              <br />
              También podés comunicarte por teléfono al <strong>+54 381 681-8108</strong>.
            </p>
          </section>

          <footer className="pp-footer">
            <p>
              Estas Condiciones del Servicio no constituyen asesoramiento legal. Para seguridad legal
              adicional, consultá con un profesional.
            </p>
          </footer>
        </article>
      </main>
      <Footer />
    </>
  );
}